import React from 'react'
import { ImageIcon } from '../common/image-icon'
import { logo_docker, logo_manual, logo_pipeline } from '../images'
import {
  stepAgentConfig,
  stepAgentConfigPipeline,
  stepInteractContrastUI,
  stepSelectDockerMethod,
  stepSelectLinuxMacOSNormalize
} from './common'
import {
  IconBitbucket,
  IconGithub
} from '@contrast-security-inc/design-system-foundations'
import { OPERATING_SYSTEM } from '../common/constants'

const commonFinalSteps = [stepInteractContrastUI]

const stepBuildGoApplication = (code1, code2, code3) => ({
  titleMsg: 'title_buildApplication',
  Content: {
    message: 'detail_buildApplicationNormalize',
    values: { code1, code2, code3 }
  }
})

const installMethods = {
  titleMsg: 'title_applicationDeploymentMethod',
  defaultIsOpen: true,
  Content: {
    options: [
      {
        value: 'manually',
        Content: {
          message: 'title_installManually'
        },
        icon: <ImageIcon src={logo_manual} alt="manually" />
      },
      {
        value: 'container',
        Content: {
          message: 'title_installContainer'
        },
        icon: <ImageIcon src={logo_docker} alt="container" />
      },
      {
        value: 'pipeline',
        Content: {
          message: 'title_installPipeline'
        },
        icon: <ImageIcon src={logo_pipeline} alt="container" />
      }
    ]
  }
}

const dockerStep = {
  titleMsg: 'title_buildImageWithAgent',
  defaultIsOpen: true,
  Content: {
    message: 'detail_installImageWithAgentGo'
  }
}

const stepsLinuxContainer = [
  {
    ...stepSelectDockerMethod,
    branchKey: 'go-container-method'
  },
  dockerStep,
  stepAgentConfig,
  ...commonFinalSteps
]

const stepSelectPipelineMethod = {
  defaultIsOpen: true,
  titleMsg: 'title_selectDeployMethodPipeline',
  Content: {
    options: [
      {
        value: 'github',
        Content: 'Github',
        icon: <IconGithub color="black" />
      },
      {
        value: 'bitbucket',
        Content: 'Bitbucket',
        icon: <IconBitbucket color="blue50" />
      }
    ]
  }
}

const githubInstallAgent = {
  defaultIsOpen: true,
  titleMsg: 'title_installAgent',
  Content: {
    message: 'detail_installGithubGo',
    values: {
      code1: `- name: Install Agent
  shell: bash
  run: |
    go run github.com/contrast-security-oss/contrast-go-installer@latest latest
    contrast-go build -o output-name-of-application
`,
      code2: `env:
  CONTRAST__API__TOKEN: \${{ secrets.ContrastAPIToken }}
  CONTRAST__APPLICATION__NAME: \${{ secrets.ContrastApplicationName }}
  CONTRAST__APPLICATION__METADATA: \${{ secrets.ContrastApplicationMetadata }}
`,
      token: '{{ secrets.ContrastAPIToken }}',
      name: '{{ secrets.ContrastApplicationName }}',
      metadata: '{{ secrets.ContrastApplicationMetadata }}',
      options: '"-javaagent:/contrast.jar"'
    }
  }
}

const bitbucketInstallAgent = {
  defaultIsOpen: true,
  titleMsg: 'title_installAgent',
  Content: {
    message: 'detail_installBitbucketGo',
    values: {
      code: `- step:
  script:
    - go run github.com/contrast-security-oss/contrast-go-installer@latest latest
`
    }
  }
}

const pipelineSteps = [
  {
    ...stepSelectPipelineMethod,
    branchKey: 'go-pipeline-method',
    branches: {
      github: [
        githubInstallAgent,
        stepAgentConfigPipeline,
        ...commonFinalSteps
      ],
      bitbucket: [
        bitbucketInstallAgent,
        stepAgentConfigPipeline,
        ...commonFinalSteps
      ]
    }
  }
]

const branches = {
  manually: [
    {
      titleMsg: 'title_runInstaller',
      defaultIsOpen: true,
      Content: { message: 'detail_runInstallerGo' }
    },
    stepBuildGoApplication(
      'contrast-go build -o [output-name-of-application]',
      'go build -o myapp ./cmd/myapp/',
      'contrast-go build -o myapp ./cmd/myapp'
    ),
    stepAgentConfig,
    ...commonFinalSteps
  ],
  container: stepsLinuxContainer,
  pipeline: pipelineSteps
}

export const goWizardStepsNormalizeAgentDownload = [
  { ...stepSelectLinuxMacOSNormalize, branchKey: OPERATING_SYSTEM.KEY },
  { ...installMethods, branchKey: 'go-install', branches }
]
